export const MESSAGING_ENABLED = process.env.REACT_APP_FEATURE_MESSAGING_ENABLED === "true"
    || process.env.REACT_APP_FEATURE_MESSAGING_ENABLED === "1";
